import ListFields from '../fragments/ListFields';

export default (languageCode: string) => /* GraphQL */ `
    mutation AddDesigns($designs: [AddDesignInput!]!, $listId: ID) {
        list: addDesigns(
            designs: $designs
            listId: $listId
            itemPresentation: { languageCode: "${languageCode}" }
        ) {
            ...ListFields
        }
    }
    ${ListFields}
`;
